import React from "react"

/**
 * Conditionally render different aspects of an address
 * @param {object} props - react props
 * @param {string} props.lineFor - the line of content to render
 * @param {boolean} props.nextLine - do we want a new line char (i.e. <br />)
 * @param {string|boolean} props.inline - is this content inline, and if so, does the next bit of content exist (to display, or not display, a comma)
 * @param {object|array} props.children - react children, to recursively display lines
 */
const AddyLine = ({ lineFor, nextLine, inline, children }) => {
  return (
    <>
      {lineFor && lineFor}
      {lineFor && inline && ", "}
      {lineFor && nextLine && <br />}
      {!!children && children}
    </>
  )
}

export default AddyLine
